<script>
    let url_category = '';
    let url_page = '';

    export let selector_product_page_element = '';
    export let selector_product_page_link = '';
    export let selector_product_page_title = '';
    export let selector_product_page_image = '';
    export let selector_product_page_description = '';
    export let selector_product_page_price = '';
    export let selector_product_page_vendorcode = '';

    export let change_url;
    export let find_selector;
</script>

<div class="section-title">Селекторы продуктов [в категории]</div>
<div class="wide-block pb-2">
    <div class="row">
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Адрес категории</span>
                    <input type="url" class="form-control" placeholder="http://example.com/catalog" bind:value={url_category} on:change={() => change_url(url_category)}/>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор элемента</span>
                    <input type="text" class="form-control" placeholder=".product" bind:value={selector_product_page_element} on:change={() => {find_selector(url_category, selector_product_page_element)}} />
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор ссылки</span>
                    <input type="text" class="form-control" placeholder="a[href]" bind:value={selector_product_page_link} on:change={() => {find_selector(url_category, selector_product_page_element + ' ' + selector_product_page_link)}} />
                </div>
            </div>
        </div>
    </div>
</div>
<div class="section-title">Селекторы продуктов [на странице]</div>
<div class="wide-block pb-2">
    <div class="row">
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Адрес продукта</span>
                    <input type="url" class="form-control" placeholder="http://example.com/catalog" bind:value={url_page} on:change={() => change_url(url_page)}/>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор заголовка</span>
                    <input type="text" class="form-control" placeholder="h1" bind:value={selector_product_page_title} on:change={() => {find_selector(url_page, selector_product_page_title)}} />
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор изображения</span>
                    <input type="text" class="form-control" placeholder="img.photo" bind:value={selector_product_page_image} on:change={() => {find_selector(url_page, selector_product_page_image)}} />
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор описания</span>
                    <input type="text" class="form-control" placeholder="div.description" bind:value={selector_product_page_description} on:change={() => {find_selector(url_page, selector_product_page_description)}} />
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор стоимости</span>
                    <input type="text" class="form-control" placeholder="span.price" bind:value={selector_product_page_price} on:change={() => {find_selector(url_page, selector_product_page_price)}} />
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор артикула</span>
                    <input type="text" class="form-control" placeholder="span.vendorcode" bind:value={selector_product_page_vendorcode} on:change={() => {find_selector(url_page, selector_product_page_vendorcode)}} />
                </div>
            </div>
        </div>
    </div>
</div>
